var App = App || {};
(function () {

	if (App.page) return;

	App.page = {

		rafId: 0,
		_resizeHandler: null,
		_scrollHandler: null,

		_setVar: function (name, valuePx) {
			document.documentElement.style.setProperty(name, String(Math.max(0, Math.round(valuePx))) + 'px');
		},

		_calcAndApply: function () {
			const header = document.querySelector('.section-header');
			const lf = document.querySelector('.longFeatures');
			if (!header || !lf) return;

			if (lf.classList.contains('collapsed')) {
				const headerH0 = header.getBoundingClientRect().height || 0;
				this._setVar('--site-header-push', 0);
				this._setVar('--table-sticky-top', headerH0);
				return;
			}

			const sentinel = lf.querySelector('.longFeatures__sentinel');
			if (!sentinel) return;

			const headerH = header.getBoundingClientRect().height || 0;
			const sentinelTop = sentinel.getBoundingClientRect().top;

			let push = headerH - sentinelTop;
			if (push < 0) push = 0;
			if (push > headerH) push = headerH;

			this._setVar('--site-header-push', push);
			this._setVar('--table-sticky-top', headerH - push);

			const thead = lf.querySelector('thead');
			if (thead) {
				thead.classList.toggle('is-stick', push >= headerH);
			}
		},

		_requestTick: function () {
			if (this.rafId) return;
			this.rafId = requestAnimationFrame(() => {
				this.rafId = 0;
				this._calcAndApply();
			});
		},

		bind: function () {
			$('.longFeaturesSwitch button').on('click', function () {
				$(this).find('ws-icon').toggleClass('rotate');
				$('.longFeatures').toggleClass('collapsed');

				App.page._requestTick();
			});
		},

		initLongFeaturesPushHeader: function () {
			const header = document.querySelector('.section-header');
			const lf = document.querySelector('.longFeatures');
			if (!header || !lf) return;

			let sentinel = lf.querySelector('.longFeatures__sentinel');
			if (!sentinel) {
				sentinel = document.createElement('div');
				sentinel.className = 'longFeatures__sentinel';
				sentinel.setAttribute('aria-hidden', 'true');
				lf.insertBefore(sentinel, lf.firstChild);
			}

			this._calcAndApply();

			if (this._scrollHandler) window.removeEventListener('scroll', this._scrollHandler);
			this._scrollHandler = () => this._requestTick();
			window.addEventListener('scroll', this._scrollHandler, { passive: true });

			if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = () => this._requestTick();
			window.addEventListener('resize', this._resizeHandler, { passive: true });
		},

		onload: function () {
			App.page.bind();
			App.page.initLongFeaturesPushHeader();
		}
	};

})();
$(App.page.onload);
